(() => {
  'use strict';
  const main = document.querySelector('#MainContent[data-tg-white]');
  if (!main?.dataset.tgWhite) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  // The intro reads the actual comparison rows so performance figures have one source.
  const samples = main.querySelector('[data-white-performance]');
  if (samples) {
    ['RTX5080', 'RTX5070', 'RTX5060'].forEach(name => {
      const row = [...main.querySelectorAll('.tg-gpv2__row')].find(el => el.querySelector('.tg-gpv2__name')?.firstChild.textContent.trim() === name);
      const score = Number(row?.querySelector('.tg-gpv2__idx')?.textContent);
      if (!Number.isFinite(score)) return;
      const item = document.createElement('div');
      item.className = 'tg-white-sample';
      const label = document.createElement('strong'); label.textContent = name.replace('RTX', 'RTX ');
      const number = document.createElement('span'); number.textContent = String(score);
      const track = document.createElement('div'); track.className = 'tg-white-sample__track';
      const bar = document.createElement('i'); bar.style.width = Math.min(100, Math.max(0, score)) + '%';
      track.append(bar); item.append(label, number, track); samples.append(item);
    });
  }
  if (main.dataset.tgWhite === 'games') {
    const grid = main.querySelector('[data-tgv3-grid]');
    if (grid) {
      const search = document.createElement('div'); search.className = 'tg-white-search';
      search.innerHTML = '<label for="tg-white-game-search">タイトルを探す</label><input id="tg-white-game-search" type="search" placeholder="例：VALORANT、原神" autocomplete="off"><p data-search-result role="status" aria-live="polite"></p>';
      grid.before(search);
      const normalize = value => value.normalize('NFKC').toLocaleLowerCase('ja');
      const tiles = [...grid.querySelectorAll('.tg-gsg3__tile')];
      search.querySelector('input').addEventListener('input', event => {
        const query = normalize(event.target.value.trim());
        let shown = 0;
        tiles.forEach(tile => {const pick = tile.querySelector('[data-gk]'); tile.hidden = !normalize(tile.textContent + ' ' + (pick?.dataset.gk || '')).includes(query); if (!tile.hidden) shown++;});
        search.querySelector('[data-search-result]').textContent = query ? (shown ? shown + 'タイトルが見つかりました。' : '該当するタイトルがありません。下のゲーム別ガイド検索もご利用ください。') : '';
      });
    }
  }
  if (!reduced.matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(({target, isIntersecting}) => {
        if (!isIntersecting) return;
        observer.unobserve(target);
        if (reduced.matches) return;
        target.animate([{opacity: .3, transform: 'translateY(14px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 480, easing: 'cubic-bezier(.16,1,.3,1)'});
      });
    }, {threshold: .08});
    main.querySelectorAll('.tg-white-intro__copy,.tg-white-intro>div:last-child,.tg-gsg3__tile,.tg-biz2__hero-copy,.tg-biz2__hero-visual,.tg-biz2__heading').forEach(el => observer.observe(el));
    reduced.addEventListener('change', () => {if(reduced.matches) main.getAnimations({subtree:true}).forEach(animation => animation.cancel());});
  }
})();
